import React from 'react';
import config from '../config';

const Footer = () => {
  return (
    <footer className="footer-minimal">
      <div className="footer-container-minimal">
        <div className="footer-logo-minimal">
          <img src={`${config.imageBaseURL}${config.paths.img}logo.png`} alt="CFO Bridge" className="footer-logo-img" />
        </div>
        <div className="footer-copyright-minimal">
          <p>© CFO Bridge Pvt. Ltd </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 